/**
 * Given an array of active filters, a filter type, and an array of selected
 * options for the type, adds and removes selected values, as appropriate, for
 * the active filters list for the type given. Does not modify active filters
 * for other types.
 * @param {Array} activeFilters - An array of active filter objects.
 * @param {string} type - The filter type to sync.
 * @param {Array} values - An array of values (strings or numbers) to sync for the given type.
 * @returns {Array} An array of active filter objects with the changes applied.
 */
const syncActiveFilters = (activeFilters, type, values) => values
  // If the value doesn't exist in the active filters list, add it.
  .reduce((acc, item) => {
    if (- 1 === activeFilters.findIndex(({
      type: filterType,
      value,
    }) => filterType === type && value === item)) {
      acc.push({
        type,
        value: item,
      });
    }

    return acc;
  }, activeFilters)

  // If the active filters list includes values that were removed, remove them.
  .filter(({ type: filterType, value }) => filterType !== type
    || values.includes(value));

export default syncActiveFilters;
